import React from 'react'
import "./work-card.css"

function WorkCard({item}) {
  return (
    <div className='work-card'>
       <img src={item.companyLogo} className='work-logo' alt="" />
       <div className='work-info'>
        <h3>
        <label className='company-name'>{item.company}</label>
        </h3>
        <h4>
        <label className='designation'>{item.designation}</label>
        </h4>
        <div className='work-dates'>
            <label>{item.dateJoining}</label> - <label>{item.dateEnd}</label>
        </div>
        <div className='work-desc'>
            <p>{item.work}</p>
        </div>
        <div className='work-desc'>
            <p>{item.work2}</p>
        </div>
        <div className='work-desc'>
            <p>{item.work3}</p>
        </div>
        <div className='work-desc'>
            <p>{item.work4}</p>
        </div>
        <div className='tech'>
        {item.Tech.map((tag)=>{
                return <label className="tag">{tag}</label>
            })}
        </div>
       </div>
    </div>
  )
}

export default WorkCard